import React from 'react'
import _ from 'lodash'
import moment, { max } from 'moment'
import { isEmpty } from 'validator'
import { createAlert } from 'dom/window'
import { combineCartBackOrderData } from './cartSelectors'
import { isCoreProduct, getSOH, getCoreRange } from '../_utils'
import { isInDeal, toggleDealBuilderListAvailable } from '../actions/promoDealsActions'
import { useDispatch } from 'react-redux'

// MEMBER / USER
export const getShowLoyaltyPoints = (userState) => {
  return userState?.details?.LoyaltyEnabled || false
}

// PRODUCT ITEM
export const getProductReplacements = (productReplacements, replacementsList) => {
  let replacements = {}
  if (!productReplacements) return replacements
  productReplacements.forEach((item, index) => {
    replacements[item] = replacementsList[item]
  })
  return replacements
}
export const getProductPromotions = (productPromotions, promotionsList) => {
  let promotions = {}
  if (!productPromotions) return promotions
  productPromotions.forEach((item, index) => {
    promotions[item] = promotionsList[item]
  })
  return promotions
}
export const getProductCocktails = (productCocktails, cocktailsList) => {
  let cocktails = {}
  if (!productCocktails) return cocktails
  productCocktails.forEach((item, index) => {
    cocktails[item] = cocktailsList[item]
  })
  return cocktails
}
export const getProductCategories = (productCategories, categoriesList) => {
  let categories = {}
  // if (!productCategories || !Object.keys(categoriesList).length) return categories; // NOTE: this was changed in 18/12 to remove elapsed time
  if (!productCategories) return categories
  productCategories.map((item, index) => {
    categories[item] = categoriesList[item]
  })

  return categories
}
export const getProductCategoriesNames = (categories) => {
  let categoriesNames = ''
  const categoriesArray = Object.entries(categories)
  if (!categoriesArray.length) return categoriesNames

  categoriesArray.map(([key, value], index) => {
    categoriesNames += value ? value.title : ''
    if (index !== categoriesArray.length - 1) {
      categoriesNames += ', '
    }
  })
  return categoriesNames
}

// INVOICES
export const getDisplayedInvoices = (invoicesList) => {
  return Object.values(invoicesList).filter((item) => {
    return Number(item.TotalDue) > 0
  })
}
export const getUnpayableInvoiceIDs = (invoicesList) => {
  let list = {}

  Object.values(invoicesList).forEach((item) => {
    if (
      item.Status === 'Marked As Paid' ||
      ((item.StatusDisplay === 'Order Received' || item.StatusDisplay === 'Picking Order') &&
        item.IsPreAuthInvoice === true)
    ) {
      list[item.ID] = true
    }
  })
  return list
}
export const getOrdersTotal = (invoicesList) => {
  const result = Object.values(invoicesList).reduce((total, item) => {
    total += Number(item.TotalDue)
    // total += Number(item.Parent10);

    return total
  }, 0)

  return Math.max(0, result)
}
export const getAmountDue = (invoicesList) => {
  const momentToday = moment()

  const result = Object.values(invoicesList).reduce((total, item) => {
    const momentDueDate = moment(item.DueDate, 'YYYY-MM-DD')

    if (momentDueDate.isSameOrBefore(momentToday, 'day') || item.Status === 'Paid') {
      total += Number(item.TotalDue)
      // total += Number(item.Parent10);
    }

    return total
  }, 0)

  return Math.max(0, result)
}

// ORDER template
export const getOrderTemplateProducts = (orderTemplateList, productsList) => {
  let orderTemplate = {}
  if (!orderTemplateList) return orderTemplate
  Object.keys(orderTemplateList).forEach((item, index) => {
    orderTemplate[item] = productsList[item]
  })
  return orderTemplate
}

// FILTERS
export const getOrderedFilters = (filters) => {
  if (filters) {
    return Object.entries(filters).reduce((newList, [key, values], index) => {
      let sortColumn = ''
      let sortDirection = ''

      let sort = filters[key]?.[0]?.sortBy || false
      switch (sort) {
        case 'Alphabetical Z-A':
          sortColumn = 'title'
          sortDirection = 'desc'
          break
        case 'Alphabetical A-Z':
          sortColumn = 'title'
          sortDirection = 'asc'
          break
        case 'Count Low to High':
          sortColumn = 'count'
          sortDirection = 'asc'
          break
        case 'Count High to Low':
          sortColumn = 'count'
          sortDirection = 'desc'
          break
        default:
          break
      }
      newList[key] = _.orderBy(Object.values(values), [sortColumn], [sortDirection])
      return newList
    }, {})
  }
}
export const hasFiltersSelected = (filters) => {
  return Object.values(filters).some((filterList) => {
    return Object.values(filterList).some((filter) => filter.checked === true)
  })
}

// PRODUCTS
export const getProductByID = (products, id) => {
  return products[id] // object
  // return products.find((item) => item.id === id); // array
}
export const getProductsArray = (products) => {
  return products ? Object.values(products) : []
}
export const sortProductsArray = (arr) => {
  return arr.sort((a, b) => a.order - b.order)
}
export const sortProductsArrayBySort = (arr) => {
  return arr.sort((a, b) => a.Sort - b.Sort)
}
export const getProductsCategories = (products) => {
  return Object.entries(products).reduce((categories, [key, product]) => {
    return {
      ...categories,
      ...product.categories,
    }
  }, {})
}
export const getOnlyParentCategories = (categories) => {
  if (typeof window.parentCategoryIDs != 'undefined') {
    const parentCategoryIDs = window.parentCategoryIDs
    let newCategories = {}

    Object.entries(categories).map(([key, value]) => {
      if (parentCategoryIDs.indexOf(Number(key)) != -1) {
        newCategories[key] = value
      }
    })

    return newCategories
  }

  return categories
}
// export const getFilteredProducts = (products, filterData) => {
//     return Object.entries(filterData).map(([key, value]) => products[key] ? products[key] : false);
// };
export const getProductsByCategory = (productsList, category) => {
  let products = {}
  Object.entries(productsList).map(([key, product]) => {
    if (product.categories && product.categories[category]) {
      products[key] = product
    }
  })
  return products
}
export const getProductsByFeatured = (productsList, featuredList) => {
  let products = {}
  Object.entries(featuredList).map(([key, product]) => {
    if (typeof productsList[key] != 'undefined' && productsList[key]) {
      products[key] = productsList[key]
    }
  })
  return products
}
export const getProductsByFilters = (productsList, filters) => {
  let products = {}
  const checkedFilters = getCheckedFilters(filters)
  const { brands, countries, regions, types, styles } = checkedFilters

  Object.entries(productsList).map(([key, product]) => {
    const { brand, region, country, type, style } = product

    if (brands.length > 0 && !brands.includes(brand)) return
    if (regions.length > 0 && !regions.includes(region)) return
    if (countries.length > 0 && !countries.includes(country)) return
    if (types.length > 0 && !types.includes(type)) return
    if (styles.length > 0 && !styles.includes(style)) return

    products[key] = product
  })

  return products
}
export const getCheckedFilters = (filters) => {
  let brands = []
  let countries = []
  let regions = []
  let types = []
  let styles = []
  if (filters.Brand) {
    brands = Object.values(filters.Brand).reduce((values, item) => {
      if (item.checked) {
        values.push(item.id)
      }
      return values
    }, [])
  }
  if (filters.Country) {
    countries = Object.values(filters.Country).reduce((values, item) => {
      if (item.checked) {
        values.push(item.id)
      }
      return values
    }, [])
  }
  if (filters.Region) {
    regions = Object.values(filters.Region).reduce((values, item) => {
      if (item.checked) {
        values.push(item.id)
      }
      return values
    }, [])
  }
  if (filters.Type) {
    types = Object.values(filters.Type).reduce((values, item) => {
      if (item.checked) {
        values.push(item.id)
      }
      return values
    }, [])
  }
  if (filters.Style) {
    styles = Object.values(filters.Style).reduce((values, item) => {
      if (item.checked) {
        values.push(item.id)
      }
      return values
    }, [])
  }
  return {
    brands: brands,
    countries: countries,
    regions: regions,
    types: types,
    styles: styles,
  }
}
export const getDisplayedProducts = (displayedList, productList) => {
  const finalList = {}

  displayedList.map((id) => {
    finalList[id] = typeof productList[id] != 'undefined' ? productList[id] : undefined
  })

  return finalList
}
export const getProductsFullInfo = (list, store, hardcodedCategories = []) => {
  const { cart, backorder, products, categories, promotions, cocktails, user, orderTemplate } = store
  const cartList = combineCartBackOrderData(products.list, cart.list, backorder.list, store)

  // const cartList = cart.list;
  const productsList = products.list

  const categoriesList = categories.list
  const promotionsList = promotions.list
  const cocktailsList = cocktails.list
  const replacementsList = products.list
  const orderTemplateList = orderTemplate.list
  let newList = {}
  const warehouseCode = user?.warehouseCode
  const customerPromo = user?.customerPromo

  Object.entries(list).map(([key, product]) => {
    newList[key] = {
      ...list[key],
      ...productsList[key],
    }
    newList[key] = {
      ...newList[key],
      ...cartList[key],
      // replacements: getProductsFullInfo(getProductReplacements(newList[key].replacements, replacementsList), store),
      replacements: getProductReplacements(newList[key].replacements, replacementsList),
      cocktails: getProductCocktails(newList[key].cocktails, cocktailsList),
      promotions: getProductPromotions(newList[key].promotions, promotionsList),
      categories: getProductCategories(newList[key].categories, categoriesList),
    }
    newList[key] = {
      ...newList[key],
      categoriesNames: getProductCategoriesNames(newList[key].categories),
    }
    // newList[key] = {
    //     ...newList[key],
    //     cartQty: getCartItemQty(newList[key]),
    //     backOrderQty: getBackOrderItemQty(newList[key]),
    //     cartTotal: getCartItemTotal(newList[key]),
    //     backOrderTotal: getBackOrderItemTotal(newList[key]),
    // };
    newList[key] = {
      ...newList[key],
      isCore: isCoreProduct(warehouseCode, newList[key].soldAt),
      hasFeaturedDiscount: customerPromo[newList[key]?.sku] && customerPromo[newList[key]?.sku]['Featured'] ? 1 : 0,
      isDeal: isInDeal(newList[key]?.sku, store),
      //isCore: getIsCoreValue(newList[key].soldAt, user),
    }
    newList[key] = {
      ...newList[key],
      //isCore: getIsCoreValue(newList[key].soldAt, user),
    }

    // Recheck stock (New implementation, but unsure)
    // TODO: Check if we are doing this or below
    if (typeof newList[key].sohRaw != 'undefined') {
      newList[key] = {
        ...newList[key],
        soh: getSOH(
          newList[key].isCore,
          warehouseCode,
          newList[key].sohRaw,
          getCoreRange(user?.enLocationID, newList[key].isCoreRange),
          newList[key].translationRedemptionID
        ),
        //soh: warehouseMapping(warehouseCode, newList[key].sohRaw),
      }
    }

    if (!newList[key].isAddToTemplate) {
      newList[key] = {
        ...newList[key],
        isAddToTemplate: orderTemplateList[key] ? true : false,
        isDeal: isInDeal(newList[key]?.sku, store),
      }
    }

    if (!newList[key].isAddToTemplate) {
      newList[key] = {
        ...newList[key],
        isAddToTemplate: cocktailsList[key] ? true : false,
      }
    }

    // // If non-core, always use melbourne base stock
    // if(typeof(newList[key].sohRaw) != 'undefined' && newList[key].isCore === false) {
    //     newList[key] = {
    //         ...newList[key],
    //         soh: getProductSoh(newList[key].sohRaw, 2) || 0,
    //     };
    // }

    // Ignore this if we don't at least have title
    if (typeof newList[key].title == 'undefined' || newList[key].title == '') {
      delete newList[key]
    }
  })

  return newList
}
export const generatePerPageInfo = (list, fullInfoList) => {
  let newList = {}

  Object.entries(list).map(([key, product]) => {
    if (typeof fullInfoList[product] != 'undefined') {
      newList[key] = {
        ...list[key],
        ...fullInfoList[product],
      }
    } else {
      newList[key] = {
        ...list[key],
      }
    }
  })

  return newList
}
export const combineProductIDsWithCartQuantity = (productIDs, productsList, cartList) => {
  let tmpList = {}

  if (typeof cartList != 'undefined' && cartList) {
    Object.values(cartList).map((item) => {
      const { id, caseQty, unitQty } = item
      if (typeof productsList[id] != 'undefined') {
        const { productID, qty_per_case, sell_by_case } = productsList[id]
        const requestedQuantity = sell_by_case === true ? caseQty : caseQty * qty_per_case + unitQty

        tmpList[productID] = requestedQuantity
      }
    })
  }

  return productIDs.map((productID) => {
    let requestedQuantity = 1

    if (typeof tmpList[productID] != 'undefined') {
      requestedQuantity = tmpList[productID]
    }

    return productID + '-' + requestedQuantity
  })
}

// COCKTAILS
export const getCocktailProducts = (cocktailProducts, productsList) => {
  let products = {}
  if (!cocktailProducts) return products
  cocktailProducts.forEach((item, index) => {
    products[item] = productsList[item]
  })
  return products
}

// CART
export const getCartArray = (list) => {
  return list ? sortByKey(Object.values(list), 'created') : []
}
export const getCartGST = (total) => {
  return total / 11
}

export const getCartRedemptionTotal = (cart) => {
  return Object.values(cart).reduce(
    (total, product) => (product?.webCategory === 'Evolution Rewards' ? total + 1 : total),
    0
  )
}

export const getCartTotal = (cart) => {
  return Object.values(cart).reduce((value, cartItem) => {
    const { caseQty, unitQty, case_price, unit_price } = cartItem
    return value + case_price * caseQty + unit_price * unitQty
  }, 0)
}

export const getCartCaseTotal = (cart) => {
  return Object.values(cart).reduce((value, cartItem) => {
    const { caseTotal } = cartItem
    return value + caseTotal
  }, 0)
}

export const getCartUnitTotal = (cart) => {
  return Object.values(cart).reduce((value, cartItem) => {
    const { unitTotal } = cartItem
    return value + unitTotal
  }, 0)
}

// export const getCartRewardPoints = (cart) => {
//     return Object.values(cart).reduce((value, cartItem) => {
//         const { rewardPoints = 0 } = cartItem;
//         return value + rewardPoints;
//     }, 0);
// };

export const getCurrentLoyaltyPoints = (cart) => {
  return Object.values(cart).reduce(
    (total, product) =>
      product.case?.WebCategory === 'Evolution Rewards'
        ? product.case?.LoyaltyPoints * product.case?.TotalUnitItems + total
        : total,
    0
  )
}

export const getCurrentLoyaltyPointsCheckout = (cartList) => {
  return cartList.reduce(
    (total, product) =>
      product?.webCategory === 'Evolution Rewards' ? product?.loyaltyPoints * product?.caseTotal + total : total,
    0
  )
}

export const checkifPromoDealExist = (products) => {
  if (products.some((item) => item.isDeal === true)) {
    // const dispatch = useDispatch()
    // dispatch(toggleDealBuilderListAvailable(true))
    return true
  }
}
export const getCartCount = (cart) => {
  return Object.values(cart).reduce(
    (total, product) => (product.case?.TotalUnitItems > 0 || product.unit?.TotalUnitItems > 0 ? total + 1 : total),
    0
  )
}
export const getCartSupplierCount = (cart) => {
  return Object.keys(cart).filter((k) => cart[k].cartQty > 0 || cart[k].unitQty > 0).length
}
export const getBackOrderCount = (cart) => {
  return Object.keys(cart).filter((k) => cart[k].caseBackOrder > 0 || cart[k].unitBackOrder > 0).length
}

// CART ITEM
export const getCartItemTotal = (product) => {
  const { case_price, caseQty, unitQty, unit_price } = product
  return (case_price || 0) * (caseQty || 0) + (unit_price || 0) * (unitQty || 0)
}
export const getCartItemQty = (product) => {
  const { sell_by_case, caseQty, qty_per_case, unitQty } = product
  const cartQty = sell_by_case ? caseQty || 0 : (caseQty || 0) * (qty_per_case || 0) + (unitQty || 0)
  // const cartQty = sell_by_case ? (caseQty || 0) : (caseQty || 0) + (unitQty || 0);
  return cartQty
}
export const getBackOrderItemTotal = (product) => {
  const { case_price, caseBackOrder, unitBackOrder, unit_price } = product
  return (case_price || 0) * (caseBackOrder || 0) + (unit_price || 0) * (unitBackOrder || 0)
}
export const getBackOrderItemQty = (product) => {
  const { sell_by_case, caseBackOrder, qty_per_case, unitBackOrder } = product
  const backOrderQty = sell_by_case
    ? caseBackOrder || 0
    : (caseBackOrder || 0) * (qty_per_case || 0) + (unitBackOrder || 0)
  return backOrderQty
}

// CART HELPER
export const hasCheckoutForm = () => {
  return document.getElementById('checkout') ||
    document.getElementById('checkout-supplier') ||
    document.getElementById('checkout-3pl')
    ? true
    : false
}

// HELPERS
export const getFeaturedProductRequest = () => {
  if (typeof window.isNewArrival != 'undefined' && window.isNewArrival) {
    return 'New Arrivals'
  }
  if (typeof window.isOnSpecials != 'undefined' && window.isOnSpecials) {
    return 'Specials'
  }

  return 'Unknown'
}

export const sortByKey = (array, key, reverse = false) => {
  return array.sort(function (a, b) {
    var x = a[key]
    var y = b[key]

    if (!reverse) {
      return x < y ? -1 : x > y ? 1 : 0
    } else {
      return x > y ? -1 : x < y ? 1 : 0
    }
  })
}

export function validateEmailValue(value) {
  // if (!/[A-Za-z0-9_.\-]+@([A-Za-z0-9_\-]+\.)+[A-Za-z]{2,4}/.test(value)) {
  if (!/^[A-Za-z0-9_.-]+@([A-Za-z0-9_-]+\.)+[A-Za-z]{2,}$/.test(value)) {
    return false
  }
  return true
}
// FORM
export const validateForm = (fieldRefs) => {
  let values = []

  // cycle fields refs
  Object.entries(fieldRefs).map(([name, field]) => {
    if (field !== null && field.props.required) {
      // Handle email fields separately
      if (field.props.type === 'email') {
        const emailValue = field.props.value
        if (!validateEmailValue(emailValue)) {
          // Return an empty string for invalid email
          values.push('')
        } else {
          values.push(emailValue)
        }
      }
      // radio/checkboxes
      if (field.props.checked !== undefined) {
        values.push(field.props.checked ? true : '')
      }
      // arrays
      else if (field.props.value instanceof Array) {
        values.push(field.props.value.length !== 0 ? true : '')
      }
      // default
      else {
        values.push(field.props.value)
      }
    }
  })
  if (!values.length) return false // first load

  return values.some((value) => {
    return isEmpty(String(value))
  })
}

export const validateFormWithError = (fieldRefs) => {
  let values = []

  // cycle fields refs
  Object.entries(fieldRefs).map(([name, field]) => {
    if (field !== null && field.props.required) {
      // radio/checkboxes
      if (field.props.checked !== undefined) {
        if (!field.props.checked) {
          if (typeof field.field != 'undefined') {
            field.field.classList.add('field--alert')
            return true
          }
        }
      }
      // arrays
      else if (field.props.value instanceof Array) {
        if (field.props.value.length === 0) {
          if (typeof field.field != 'undefined') {
            field.field.classList.add('field--alert')
            return true
          }
        }
      }
      // default
      else {
        if (!field.props.value) {
          if (typeof field.field != 'undefined') {
            field.field.classList.add('field--alert')
            return true
          }
        }
      }
    }
  })

  if (!values.length) return false // first load
}

export const getAvailableInvoicePaymentOptions = (globalConfig, excludedPayment = null) => {
  const accountOption = {
    label: 'Account',
    value: 'order-account',
  }

  const cardOption = {
    label: 'Credit Card',
    value: 'order-airwallex-card',
  }

  const zipOption = {
    label: '(Buy now, pay later)',
    value: 'order-tillpayments-zippay',
  }
  const poliOption = {
    label: '(Bank Transfer)',
    value: 'order-tillpayments-polipay',
  }

  const availablePaymentOptions = globalConfig?.invoicePaymentMethods
    ?.filter((x) => x !== excludedPayment)
    ?.map((method) => {
      if (method === 'order-account') {
        return accountOption
      }

      if (method === 'order-airwallex-card') {
        return cardOption
      }

      if (method === 'order-tillpayments-zippay') {
        return zipOption
      }
      if (method === 'order-tillpayments-polipay') {
        return poliOption
      }
    })

  return availablePaymentOptions
}

export const getAvailablePaymentOptions = (globalConfig, excludedPayment = null) => {
  const accountOption = {
    label: 'Account',
    value: 'order-account',
  }

  const cardOption = {
    label: 'Credit Card',
    value: 'order-airwallex-card',
  }

  const zipOption = {
    label: '(Buy now, pay later)',
    value: 'order-tillpayments-zippay',
  }
  const poliOption = {
    label: '(Bank Transfer)',
    value: 'order-tillpayments-polipay',
  }

  const availablePaymentOptions = globalConfig?.checkoutPaymentMethods
    ?.filter((x) => x !== excludedPayment)
    ?.map((method) => {
      if (method === 'order-account') {
        return accountOption
      }

      if (method === 'order-airwallex-card') {
        return cardOption
      }

      if (method === 'order-tillpayments-zippay') {
        return zipOption
      }
      if (method === 'order-tillpayments-polipay') {
        return poliOption
      }
    })

  return availablePaymentOptions
}

export const getInvoicePaymentMethod = (selectedPaymentMethod) => {
  if (selectedPaymentMethod === 'order-airwallex-card') {
    return 'invoice-airwallex-card'
  }

  if (selectedPaymentMethod === 'order-tillpayments-zippay') {
    return 'invoice-tillpayments-zippay'
  }
  if (selectedPaymentMethod === 'order-tillpayments-polipay') {
    return 'invoice-tillpayments-polipay'
  }
}

export const getPaymentGateway = (selectedPaymentMethod) => {
  if (selectedPaymentMethod === 'order-airwallex-card') {
    return 'airwallex-card'
  }

  if (selectedPaymentMethod === 'order-tillpayments-zippay') {
    return 'tillpayments-zippay'
  }
  if (selectedPaymentMethod === 'order-tillpayments-polipay') {
    return 'tillpayments-polipay'
  }

  if (selectedPaymentMethod === 'order-account') {
    return 'order-account'
  }
}

export const getCardId = (selectedPaymentMethod, selectedCreditCard) => {
  if (
    selectedPaymentMethod !== 'order-airwallex-card' &&
    selectedPaymentMethod !== 'order-airwallex-card-authorization'
  ) {
    return 0
  }

  return parseInt(selectedCreditCard, 10) || 0
}

export const renderPaymentIconImage = (selectedPaymentMethod) => {
  if (!selectedPaymentMethod) return null

  if (selectedPaymentMethod === 'order-account') {
    return (
      <React.Fragment>
        <i className="icon icon-login payment-icon-image" />
      </React.Fragment>
    )
  }

  if (selectedPaymentMethod === 'order-airwallex-card') {
    return (
      <React.Fragment>
        <i className="icon icon-credit-card payment-icon-image" />
      </React.Fragment>
    )
  }

  if (selectedPaymentMethod === 'order-tillpayments-zippay') {
    return (
      <React.Fragment>
        <img
          src="/resources/themes/paramountliquor-theme/img/icon/Zip_Pay.svg"
          className="payment-icon-image payment-zip"
        />
      </React.Fragment>
    )
  }
  if (selectedPaymentMethod === 'order-tillpayments-polipay') {
    return (
      <React.Fragment>
        <img
          src="/resources/themes/paramountliquor-theme/img/icon/polipay.png"
          className="payment-icon-image payment-poli"
        />
      </React.Fragment>
    )
  }
}

export const showURLErrorMessage = () => {
  const url = new URL(window.location.href)
  const message = url.searchParams.get('message')
  const type = url.searchParams.get('type')

  if (type === 'error' && message) {
    createAlert({ message: message }, 'error')
  }
}

export const convertLoyaltyTabsToReactSelect = (tabOptions) => {
  return tabOptions.map((option, index) => {
    return {
      label: option.Title,
      value: option.Title,
    }
  })
}

export const intFloatChecker = (num) => {
  let modified = num
  if (typeof num == 'number' && !isNaN(num)) {
    if (Number.isInteger(num)) {
      modified = num
    } else {
      modified = parseFloat(num).toFixed(2)
    }
  } else {
    modified = num
  }
  return modified
}

export const validateFormNegativeValues = (fieldRefs) => {
  let values = []

  // cycle fields refs
  Object.entries(fieldRefs).map(([name, field]) => {
    if (field !== null) {
      // default
      if (field.props.value < 0) {
        if (typeof field.field != 'undefined') {
          field.field.classList.add('field--alert')
          return true
        }
      }
    }
  })

  if (!values.length) return false // first load
}

export const hasCoreRangeCheck = (list = []) => {
  if (list.length === 0) {
    return false
  }

  for (let i = 0; i < list.length; i++) {
    if (list[i].isCoreRange === true) {
      return true
    }
  }

  return false
}
